import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

export const MarkdownList = ({ ...props }) => {
  return React.createElement(`ul`, {
    className: clsx(styles.ul),
    ...props,
  });
};
